import { Container, NoPermissionState, PageHeader } from '@stayafrica/ui';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useCan, useSession } from '@/features/auth/session';
import { HousekeepingBoard } from '@/features/housekeeping/HousekeepingBoard';
import { formatDate } from '@/lib/format';

export const Route = createFileRoute('/_app/today/housekeeping')({ component: HousekeepingPage });

/** Opérations › Ménage du jour (SCR-014), utilisable au téléphone. */
function HousekeepingPage() {
  const { t, i18n } = useTranslation(['housekeeping', 'nav', 'common']);
  const { user } = useSession();
  const canRead = useCan('housekeeping.read');

  if (!canRead) {
    return (
      <Container>
        <NoPermissionState
          title={t('common:states.noPermissionTitle')}
          description={t('common:states.noPermissionDescription')}
        />
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader
        title={t('housekeeping:title')}
        subtitle={t('housekeeping:subtitle', {
          date: formatDate(new Date().toISOString(), i18n.language, user.tenant.timezone),
        })}
        breadcrumb={[
          { label: t('common:appName'), link: <Link to="/">{t('common:appName')}</Link> },
          { label: t('nav:items.operations') },
          { label: t('housekeeping:title') },
        ]}
      />
      <HousekeepingBoard />
    </Container>
  );
}
